export default __webpack_public_path__ + "static/media/freeToJoin_nocashbak_nodiscount_no_prepaid_card.7bbbc5aa.png";